// ── Mock data — Phase 1 ──────────────────────────────────────────────────────
const r  = (lo, hi, dp=2) => +(Math.random()*(hi-lo)+lo).toFixed(dp);
const ri = (lo, hi)       => Math.floor(Math.random()*(hi-lo+1))+lo;
const spk = (base, n=10)  => Array.from({length:n},(_,i)=>+(base+Math.sin(i*.9)*base*.04).toFixed(2));

// ── TAB 1 ─────────────────────────────────────────────────────────────────────
export const INDICES = [
  {id:'NIFTY50',  name:'NIFTY 50',   price:24512.35, chg:112.40,  pct:0.46,  spark:spk(24400)},
  {id:'BANKNIFTY',name:'Bank Nifty', price:52340.15, chg:-198.30, pct:-0.38, spark:spk(52500)},
  {id:'SENSEX',   name:'Sensex',     price:80412.60, chg:310.25,  pct:0.39,  spark:spk(80100)},
  {id:'VIX',      name:'India VIX',  price:13.42,    chg:-0.58,   pct:-4.14, spark:spk(14)},
];

export const SGX = {id:'SGX',name:'SGX Nifty',price:24580,chg:68,pct:0.28,spark:spk(24510),note:'Pre-market'};

export const COMMODITIES = [
  {id:'NG1',      name:'US NG1',          price:2.318,   chg:-0.042,pct:-1.78, unit:'$/MMBtu',spark:spk(2.36),  primary:true, pairLabel:'MCX NG'},
  {id:'MCXNG',    name:'MCX Nat Gas',     price:194.4,   chg:-3.5,  pct:-1.77, unit:'₹/MMBtu',spark:spk(198),   secondary:true},
  {id:'USOIL',    name:'US Oil (WTI)',    price:78.42,   chg:0.88,  pct:1.13,  unit:'$/bbl',  spark:spk(77.5),  primary:true, pairLabel:'MCX Crude'},
  {id:'MCXCRUDE', name:'MCX Crude',       price:6542,    chg:72,    pct:1.11,  unit:'₹/bbl',  spark:spk(6470),  secondary:true},
  {id:'XAUUSD',   name:'Gold (XAUUSD)',   price:2312,    chg:8.4,   pct:0.36,  unit:'$/oz',   spark:spk(2303),  primary:true, pairLabel:'Gold MCX'},
  {id:'GOLDMCX',  name:'Gold MCX',        price:72340,   chg:-120,  pct:-0.17, unit:'₹/10g',  spark:spk(72460), secondary:true},
  {id:'XAGUSD',   name:'Silver (XAGUSD)', price:27.42,   chg:0.18,  pct:0.66,  unit:'$/oz',   spark:spk(27.2),  primary:true, pairLabel:'Silver MCX'},
  {id:'SILVMCX',  name:'Silver MCX',      price:88420,   chg:580,   pct:0.66,  unit:'₹/kg',   spark:spk(87840), secondary:true},
  {id:'BTCUSD',   name:'Bitcoin (BTC)',   price:82450,   chg:-1240, pct:-1.48, unit:'USD',    spark:spk(83690), primary:true},
  {id:'USDINR',   name:'USD/INR',         price:83.42,   chg:-0.08, pct:-0.10, unit:'₹',      spark:spk(83.5),  primary:true},
];

export const EIA = {
  nextDate:'2025-08-14', nextTime:'22:30 IST',
  lastActual:-32, lastForecast:-28, lastSurprise:-4, tag:'Bearish',
  history:[
    {week:'Jul 18',actual:-32,forecast:-28,surprise:-4,bull:false},
    {week:'Jul 11',actual:40, forecast:35, surprise:5, bull:false},
    {week:'Jul 4', actual:-18,forecast:-20,surprise:2, bull:true},
    {week:'Jun 27',actual:55, forecast:48, surprise:7, bull:false},
    {week:'Jun 20',actual:-8, forecast:-5, surprise:-3,bull:true},
  ],
};

export const BREADTH = {
  nifty50: { today:{adv:32,dec:18},   hist:[{a:60,d:40},{a:70,d:30},{a:45,d:55},{a:38,d:62},{a:30,d:70},{a:35,d:65},{a:42,d:58},{a:28,d:72},{a:55,d:45},{a:64,d:36}]},
  fo:      { today:{adv:134,dec:46},  hist:[{a:62,d:38},{a:71,d:29},{a:50,d:50},{a:40,d:60},{a:32,d:68},{a:38,d:62},{a:44,d:56},{a:30,d:70},{a:57,d:43},{a:65,d:35}]},
  total:   { today:{adv:1342,dec:712},hist:[{a:62,d:38},{a:70,d:30},{a:50,d:50},{a:40,d:60},{a:30,d:70},{a:30,d:70},{a:40,d:60},{a:50,d:50},{a:40,d:60},{a:38,d:62}]},
};

export const SECTORS = [
  {name:'IT',pct:1.82},{name:'Auto',pct:1.24},{name:'Pharma',pct:0.88},
  {name:'Bank',pct:0.42},{name:'Pvt Bank',pct:0.38},{name:'Fin Svc',pct:0.31},
  {name:'FMCG',pct:0.12},{name:'Healthcare',pct:-0.08},{name:'Infra',pct:-0.22},
  {name:'Con Dur',pct:-0.34},{name:'Oil & Gas',pct:-0.51},{name:'Energy',pct:-0.64},
  {name:'PSU Bank',pct:-0.72},{name:'Metal',pct:-0.89},{name:'Realty',pct:-1.14},{name:'Media',pct:-1.48},
];
export const BROAD = [
  {name:'Nifty 50',pct:0.46},{name:'Nifty 100',pct:0.38},{name:'Nifty 200',pct:0.22},
  {name:'Next 50',pct:0.18},{name:'Midcap 100',pct:-0.12},{name:'Midcap 50',pct:-0.28},
  {name:'Smallcap 100',pct:-0.44},{name:'Smallcap 50',pct:-0.58},{name:'Nifty 500',pct:-0.19},{name:'Microcap 250',pct:-0.72},
];

export const FO_MOVERS = {
  gainers:[{name:'LTIM',pct:4.82},{name:'PERSISTENT',pct:3.91},{name:'INFY',pct:3.42},{name:'HCLTECH',pct:2.88},{name:'TCS',pct:2.44},{name:'WIPRO',pct:2.11},{name:'TECHM',pct:1.94},{name:'MPHASIS',pct:1.72},{name:'COFORGE',pct:1.48},{name:'KPIT',pct:1.32}],
  losers: [{name:'ZOMATO',pct:-3.44},{name:'PAYTM',pct:-2.98},{name:'DELHIVERY',pct:-2.64},{name:'PVR',pct:-2.21},{name:'IDEA',pct:-1.94},{name:'SUZLON',pct:-1.82},{name:'IRCTC',pct:-1.64},{name:'INDIGO',pct:-1.41},{name:'TATACHEM',pct:-1.28},{name:'VEDL',pct:-1.14}],
  volume: [{name:'RELIANCE',vol:'18.4M'},{name:'HDFCBANK',vol:'14.2M'},{name:'SBI',vol:'12.8M'},{name:'ITC',vol:'11.4M'},{name:'ICICIBANK',vol:'10.9M'},{name:'BAJFINANCE',vol:'9.4M'},{name:'AXISBANK',vol:'8.8M'},{name:'INFY',vol:'8.2M'},{name:'TCS',vol:'7.6M'},{name:'HDFCLIFE',vol:'6.9M'}],
};

export const EXTREMES = {
  highs:[{s:'LTIM',price:'5,840'},{s:'PERSISTENT',price:'4,920'},{s:'KPIT',price:'1,680'},{s:'HCLTECH',price:'1,924'},{s:'BPCL',price:'448'},{s:'ONGC',price:'284'}],
  lows: [{s:'ZOMATO',price:'142'},{s:'DELHIVERY',price:'328'},{s:'PVR',price:'1,180'},{s:'IDEA',price:'11.2'},{s:'YESBANK',price:'17.8'}],
};

export const OVERNIGHT = [
  {cat:'Macro',       text:'US CPI 3.0% YoY vs 3.2% expected — tech and rate-sensitive sectors likely to benefit at open'},
  {cat:'Energy',      text:'Crude oil -1.2% overnight on surprise SPR release; MCX Crude may gap down at open'},
  {cat:'Global',      text:'China PMI weaker than forecast; metals and commodity stocks could face pressure'},
  {cat:'FII Flows',   text:'Dollar index fell 0.4%; USD/INR may open stronger — net positive for Indian equities'},
  {cat:'Macro',       text:'Fed minutes showed data-dependent stance; rate cut probability for September unchanged at 62%'},
];

export const NEWS = [
  {id:1, cat:'Indian Equity',       catKey:'ie',  icon:'📈', src:'Moneycontrol',  time:'14m', hl:'IT sector leads rally as US inflation cools; LTIM, Infy surge over 4%'},
  {id:2, cat:'Natural Gas & Energy',catKey:'ng',  icon:'⛽', src:'NGI',           time:'28m', hl:'US natural gas storage draw smaller than expected; prices dip below $2.35'},
  {id:3, cat:'FII Flows',           catKey:'fii', icon:'💸', src:'ET Markets',    time:'1h',  hl:'FIIs net buyers of ₹3,412 cr in equities; DIIs also positive at ₹1,840 cr'},
  {id:4, cat:'Macro',               catKey:'mac', icon:'🏦', src:'Reuters India', time:'2h',  hl:'RBI Governor signals no immediate rate cut; inflation watch continues'},
  {id:5, cat:'Global Markets',      catKey:'gl',  icon:'🌐', src:'Bloomberg',     time:'3h',  hl:'S&P 500 closes flat; Nasdaq gains 0.4% on tech strength ahead of Fed minutes'},
  {id:6, cat:'NSE/BSE Circulars',   catKey:'circ',icon:'📋', src:'NSE',           time:'4h',  hl:'CIRCULAR: Revised lot sizes for F&O contracts effective September expiry'},
  {id:7, cat:'Natural Gas & Energy',catKey:'ng',  icon:'⛽', src:'OilPrice.com',  time:'5h',  hl:'LNG exports remain near record highs; Europe demand keeps US prices supported'},
  {id:8, cat:'Indian Equity',       catKey:'ie',  icon:'📈', src:'Business Std',  time:'8h',  hl:'Auto stocks up on strong monthly sales data; Maruti, M&M hit 52-week highs'},
  {id:9, cat:'Macro',               catKey:'mac', icon:'🏦', src:'LiveMint',      time:'10h', hl:'India CPI inflation rises to 5.1% in July; within RBI comfort band'},
  {id:10,cat:'Geopolitical',        catKey:'geo', icon:'🌍', src:'Reuters',       time:'11h', hl:'Middle East supply concerns ease after diplomatic talks; crude dips slightly'},
];

// ── TAB 2 ─────────────────────────────────────────────────────────────────────
const SECTOR_LIST = ['IT','Banking','Auto','Pharma','FMCG','Metal','Realty','Energy','Infra','PSU'];
const genRows = (names) => names.map((name,i) => {
  const streak = i%3===0 ? `↑${ri(2,6)}` : `↓${ri(1,4)}`;
  return {
    name, sector:SECTOR_LIST[i%SECTOR_LIST.length], streak,
    d1:r(-3,3),d3:r(-6,6),d5:r(-9,9),d10:r(-13,13),
    d15:r(-16,16),d30:r(-22,22),d90:r(-32,32),
    vsNifty:r(-9,9), spark:spk(r(100,300)),
    daily:Array.from({length:20},()=>r(-3,3)),
  };
});

export const INDEX_ROWS = genRows([
  'NIFTY 50','Bank Nifty','Sensex','India VIX','Nifty IT','Nifty Auto',
  'Nifty Pharma','Nifty Bank','Nifty FMCG','Nifty Metal','Nifty Realty',
  'Nifty Energy','Nifty Infra','Nifty Media','PSU Bank','Pvt Bank',
  'Healthcare','Consumer Dur','Oil & Gas','Fin Svc','Nifty 100',
  'Nifty 200','Nifty 500','Next 50','Midcap 50','Midcap 100','Smallcap 50',
]);
export const FO_ROWS = genRows([
  'RELIANCE','TCS','HDFCBANK','INFY','ICICIBANK','HINDUNILVR','ITC','SBIN',
  'BAJFINANCE','LT','AXISBANK','KOTAKBANK','ASIANPAINT','MARUTI','TITAN',
  'ULTRACEMCO','NESTLEIND','WIPRO','HCLTECH','TECHM','SUNPHARMA','DRREDDY',
  'CIPLA','DIVISLAB','APOLLOHOSP','ONGC','BPCL','IOC','GAIL','NTPC',
  'POWERGRID','TATAMOTORS','M&M','BAJAJ-AUTO','EICHERMOT','TATASTEEL',
  'JSWSTEEL','HINDALCO','VEDL','COALINDIA','ADANIENT','ADANIPORTS',
  'ZOMATO','PAYTM','DELHIVERY','HDFC','BAJAJFINSV','SBILIFE','ICICIGI',
  'HDFCLIFE','INDIGO','IRCTC','JUBLFOOD','HAVELLS','POLYCAB','VOLTAS',
  'AMBUJACEM','ACC','SHREECEM','TORNTPHARM','AUROPHARMA','PERSISTENT',
  'LTIM','MPHASIS','COFORGE','KPIT','ABB','SIEMENS','BEL','HAL','BHEL',
]);

export const WATCHLISTS_INIT = [
  {id:1,name:'Core Swing',stocks:['RELIANCE','TCS','INFY','HCLTECH','WIPRO','MARUTI','BAJFINANCE']},
  {id:2,name:'NG Correlated',stocks:['ONGC','BPCL','IOC','GAIL','RELIANCE']},
  {id:3,name:'Momentum Watch',stocks:['LTIM','PERSISTENT','KPIT','COFORGE','MPHASIS','ABB','HAL']},
];

export const AI_FEEDBACK = [
  {date:'2025-08-07',obs:[
    {type:'Momentum',   tagKey:'momentum',   fact:'MPHASIS and HCLTECH positive 5+ consecutive sessions.',        impl:'Both in IT — sector-level strength, not stock-specific.'},
    {type:'Rotation',   tagKey:'rotation',   fact:'Nifty IT positive 8 of last 10 sessions. Nifty Metal negative 7 of 10.',impl:'IT +4.2% vs Metal -5.8% over 5 days — divergence widening.'},
    {type:'Streak',     tagKey:'streak',     fact:'JUBLFOOD down 9 of last 10 sessions — most persistent negative streak in F&O universe.',impl:'Down 22.8% over 30D vs NIFTY -1.3%.'},
    {type:'Breadth',    tagKey:'breadth',    fact:'72% of F&O stocks negative over 15 days while NIFTY 50 is nearly flat.',impl:'Index being held up by a small number of large-cap heavyweights.'},
    {type:'Rel. Strength',tagKey:'relstrength',fact:'SUNPHARMA outperformed NIFTY by +7.8% over 30D.',impl:'Largest positive RS divergence in F&O universe currently.'},
  ]},
  {date:'2025-08-06',obs:[
    {type:'Warning',       tagKey:'warning',    fact:'India VIX spiked to 16.2 intraday — elevated for a calm session.',impl:'Hedged positions recommended for overnight holds.'},
    {type:'Streak',        tagKey:'streak',     fact:'Metal sector ↓3 consecutive days.',impl:'Watch TATASTEEL support at 150-day MA.'},
    {type:'Breadth',       tagKey:'breadth',    fact:'Advances only 600 vs 1,450 declines.',impl:'Broad market weakness; index gains narrow-based, not confirmed by breadth.'},
  ]},
  {date:'2025-08-05',obs:[
    {type:'Rotation',      tagKey:'rotation',   fact:'Capital rotating out of PSU Banks into IT and Pharma.',impl:'Sector breadth confirms institutional shift underway.'},
    {type:'Rel. Strength', tagKey:'relstrength',fact:'MARUTI outperforming NIFTY by 3.2% over 10 days.',impl:'TATAMOTORS lagging by -2.1% — within-sector divergence.'},
  ]},
];

// ── TAB 3 ─────────────────────────────────────────────────────────────────────
export const OC_META = {
  instrument:'NIFTY', spot:24512, futPrice:24558, synthFut:24545,
  atm:24500, atmIV:13.2, straddle:312, pcr:1.18, maxPain:24400, ivPctile:22,
  expiries:['08 Aug','15 Aug','22 Aug','28 Aug','26 Sep'],
};
const CE_MAX=850000, PE_MAX=920000;
export const OC_ROWS = [-500,-400,-300,-200,-150,-100,-50,0,50,100,150,200,300,400,500].map(off=>{
  const strike=24500+off, isATM=off===0;
  const ceOI=Math.max(50000,CE_MAX*(1-Math.abs(off)/800));
  const peOI=Math.max(50000,PE_MAX*(1-Math.abs(off)/700));
  const ceLTP=Math.max(1,156-off*.9+r(-5,5));
  const peLTP=Math.max(1,156+off*.9+r(-5,5));
  return {
    strike,isATM,
    ceLTP:+ceLTP.toFixed(1),ceDelta:+(0.5+off/1000).toFixed(2),ceIV:+(13.2+Math.abs(off)*.003).toFixed(1),
    ceOI:Math.round(ceOI),ceDeltaOI:+r(-15,15).toFixed(1),
    peLTP:+peLTP.toFixed(1),peDelta:+(-0.5+off/1000).toFixed(2),peIV:+(13.2+Math.abs(off)*.003).toFixed(1),
    peOI:Math.round(peOI),peDeltaOI:+r(-15,15).toFixed(1),
    pcr:+(peOI/ceOI).toFixed(2),
  };
});

// ── MCX Option Chain mock data ─────────────────────────────────────────────────
// Each MCX instrument: spot price, lot size, strike interval, expiry structure
function mcxRows(atmPrice, interval, ltpBase) {
  const offsets = [-5,-4,-3,-2,-1,0,1,2,3,4,5].map(n => n*interval);
  const CE_M = 40000, PE_M = 38000;
  return offsets.map(off => {
    const strike = atmPrice + off;
    const ceOI = Math.max(5000, CE_M*(1-Math.abs(off)/(interval*8)));
    const peOI = Math.max(5000, PE_M*(1-Math.abs(off)/(interval*7)));
    const ceLTP = Math.max(0.1, ltpBase - off*0.6 + r(-ltpBase*.02, ltpBase*.02));
    const peLTP = Math.max(0.1, ltpBase + off*0.6 + r(-ltpBase*.02, ltpBase*.02));
    return {
      strike:+strike.toFixed(0), isATM:off===0,
      ceLTP:+ceLTP.toFixed(1), ceDelta:+(0.5+off/(interval*20)).toFixed(2),
      ceIV:+(22+Math.abs(off)/(interval*.8)).toFixed(1),
      ceOI:Math.round(ceOI), ceDeltaOI:+r(-20,20).toFixed(1),
      peLTP:+peLTP.toFixed(1), peDelta:+(-0.5+off/(interval*20)).toFixed(2),
      peIV:+(22+Math.abs(off)/(interval*.8)).toFixed(1),
      peOI:Math.round(peOI), peDeltaOI:+r(-20,20).toFixed(1),
      pcr:+(peOI/ceOI).toFixed(2),
    };
  });
}

export const MCX_INSTRUMENTS = {
  NATURALGAS: {
    label:'Natural Gas', exchange:'MCX', unit:'₹/MMBtu', lotSize:1250,
    spot:194.4, futPrice:196.2, synthFut:195.8,
    atm:194, atmIV:28.4, straddle:5.2, pcr:0.94, maxPain:192, ivPctile:58,
    expiries:['26 Aug','25 Sep','28 Oct'],
    strikeInterval:2,
    rows: mcxRows(194, 2, 3.8),
  },
  CRUDEOIL: {
    label:'Crude Oil', exchange:'MCX', unit:'₹/bbl', lotSize:100,
    spot:6542, futPrice:6558, synthFut:6551,
    atm:6500, atmIV:24.8, straddle:182, pcr:1.06, maxPain:6450, ivPctile:44,
    expiries:['19 Aug','17 Sep','21 Oct'],
    strikeInterval:50,
    rows: mcxRows(6500, 50, 120),
  },
  GOLD: {
    label:'Gold', exchange:'MCX', unit:'₹/10g', lotSize:100,
    spot:72340, futPrice:72480, synthFut:72420,
    atm:72000, atmIV:12.4, straddle:820, pcr:1.22, maxPain:71500, ivPctile:32,
    expiries:['05 Aug','03 Sep','05 Oct'],
    strikeInterval:500,
    rows: mcxRows(72000, 500, 580),
  },
  GOLDM: {
    label:'Gold Mini', exchange:'MCX', unit:'₹/10g', lotSize:10,
    spot:72340, futPrice:72480, synthFut:72420,
    atm:72000, atmIV:12.6, straddle:840, pcr:1.18, maxPain:71500, ivPctile:33,
    expiries:['05 Aug','03 Sep','05 Oct'],
    strikeInterval:500,
    rows: mcxRows(72000, 500, 590),
  },
  SILVER: {
    label:'Silver', exchange:'MCX', unit:'₹/kg', lotSize:30,
    spot:88420, futPrice:88650, synthFut:88540,
    atm:88000, atmIV:18.2, straddle:1240, pcr:0.88, maxPain:87500, ivPctile:52,
    expiries:['05 Sep','05 Dec','05 Mar'],
    strikeInterval:1000,
    rows: mcxRows(88000, 1000, 920),
  },
  SILVERM: {
    label:'Silver Mini', exchange:'MCX', unit:'₹/kg', lotSize:5,
    spot:88420, futPrice:88650, synthFut:88540,
    atm:88000, atmIV:18.4, straddle:1260, pcr:0.86, maxPain:87500, ivPctile:53,
    expiries:['05 Sep','05 Dec','05 Mar'],
    strikeInterval:1000,
    rows: mcxRows(88000, 1000, 930),
  },
};

// ── TAB 4 ─────────────────────────────────────────────────────────────────────
const SCAN_DATES = Array.from({length:10},(_,i)=>{
  const d=new Date('2025-08-07'); d.setDate(d.getDate()-(9-i));
  return d.toLocaleDateString('en-IN',{day:'2-digit',month:'short'});
});
export const SCANNER = {
  dates: SCAN_DATES,
  strategy1:{
    name:'KAMA Pullback + EMA Trigger',
    desc:'KAMA(20,2,30) daily > weekly · Low touched KAMA in last 5 days · EMA(3) crossed above EMA(9) within 1–3 candles',
    params:{atrThreshold:1.5,rangeThreshold:8,volMultiplier:1.2,rsLookback:10},
    bullish:['LTIM','PERSISTENT','HCLTECH','KPIT','COFORGE','WIPRO','TECHM','SUNPHARMA','DRREDDY','DIVISLAB','MARUTI','BAJAJ-AUTO','RELIANCE','ONGC'].map((name,i)=>{
      const log=Array.from({length:10},()=>Math.random()>.4);
      // Only first 8 qualify today — rest are historical only (visible in All 10D)
      if (i < 8) log[9]=true; else log[9]=false;
      const streak=(()=>{let s=0;for(let j=9;j>=0;j--){if(log[j])s++;else break;}return s;})();
      return {name,sector:SECTOR_LIST[i%SECTOR_LIST.length],log,streak,stars:[2,3,3,4,4,5,5,4,3,3,2,3,4,3][i]||3};
    }),
    bearish:['ZOMATO','DELHIVERY','PVR','YESBANK','IDEA'].map((name,i)=>{
      const log=Array.from({length:10},()=>Math.random()>.5);
      // Only first 3 qualify today
      if (i < 3) log[9]=true; else log[9]=false;
      const streak=(()=>{let s=0;for(let j=9;j>=0;j--){if(log[j])s++;else break;}return s;})();
      return {name,sector:SECTOR_LIST[i%SECTOR_LIST.length],log,streak,stars:3-i%2};
    }),
  },
};

// ── TAB 5 ─────────────────────────────────────────────────────────────────────
export const OPEN_POS = [
  {
    groupId:'20250805_LTIM_KAMA',strategy:'KAMA Pullback',underlying:'LTIM',
    legs:[{utn:10041,inst:'LTIM AUG 5600 CE',bs:'Buy',type:'CE',lots:2,lotSize:50,entry:88,current:132}],
    pnl:(132-88)*50*2, entryDate:'2025-08-05',
    conds:[{label:'KAMA daily > weekly',st:'ok'},{label:'Low touched KAMA',st:'ok'},{label:'EMA3 × EMA9',st:'ok'}],
  },
  {
    groupId:'20250806_SUNPHARMA_KAMA',strategy:'KAMA Pullback',underlying:'SUNPHARMA',
    legs:[{utn:10042,inst:'SUNPHARMA AUG 1700 CE',bs:'Buy',type:'CE',lots:1,lotSize:200,entry:42,current:38}],
    pnl:(38-42)*200, entryDate:'2025-08-06',
    conds:[{label:'KAMA daily > weekly',st:'ok'},{label:'Low touched KAMA',st:'ok'},{label:'EMA3 × EMA9',st:'warn'}],
  },
  {
    groupId:'20250807_NIFTY_MANUAL',strategy:'Manual',underlying:'NIFTY',
    legs:[{utn:10043,inst:'NIFTY AUG 24400 PE',bs:'Buy',type:'PE',lots:3,lotSize:25,entry:62,current:48}],
    pnl:(48-62)*25*3, entryDate:'2025-08-07',
    conds:[], notes:'Hedge against open longs. Remove if NIFTY closes above 24,600.',
  },
];

export const TRADE_LOG = [
  {utn:10040,groupId:'20250801_TCS_KAMA', underlying:'TCS',     strategy:'KAMA Pullback',inst:'TCS AUG 4000 CE',  bs:'Buy', type:'CE',lots:1,lotSize:75, acct:'Zerodha',entry:188,exit:312,  dateOpen:'2025-08-01',dateClose:'2025-08-05',pnl:(312-188)*75,  status:'Closed',notes:''},
  {utn:10039,groupId:'20250731_INFY_KAMA',underlying:'INFY',    strategy:'KAMA Pullback',inst:'INFY AUG 1800 CE', bs:'Buy', type:'CE',lots:2,lotSize:200,acct:'Zerodha',entry:52, exit:38,   dateOpen:'2025-07-31',dateClose:'2025-08-03',pnl:(38-52)*200*2, status:'Closed',notes:'SL hit'},
  {utn:10038,groupId:'20250729_RELIANCE_M',underlying:'RELIANCE',strategy:'Manual',      inst:'RELIANCE FUTURES',bs:'Buy', type:'FUT',lots:1,lotSize:250,acct:'Zerodha',entry:3020,exit:3085,dateOpen:'2025-07-29',dateClose:'2025-08-01',pnl:(3085-3020)*250,status:'Closed',notes:'Budget positional'},
];

export const ANALYTICS = {
  total:12, openCount:4, closedCount:8,
  wins:5, losses:3,
  winRate:62.5, twoX:37.5, twoXCount:3,
  netPnl:24350, avgWin:8200, avgLoss:-3280,
  bestTrade:  { name:'WIPRO S1 · +340%',    pnl:18750 },
  worstTrade: { name:'BAJFINANCE S1',       pnl:-5400 },
  byStrategy:[
    { name:'Strategy 1 — KAMA Pullback', trades:10, winRate:60, twoX:40, pnl:28100, avgReturn:2810, best:18750, worst:-5400 },
    { name:'Manual',                     trades:2,  winRate:50, twoX:0,  pnl:-3750, avgReturn:-1875,best:1800,  worst:-5550 },
  ],
  byUnderlying:[
    { name:'WIPRO',       trades:3, winRate:100, pnl:24400,  avgReturnPct:218 },
    { name:'TATAMOTORS',  trades:2, winRate:50,  pnl:6200,   avgReturnPct:74  },
    { name:'HDFCBANK',    trades:3, winRate:33,  pnl:-4100,  avgReturnPct:-42 },
    { name:'NIFTY',       trades:2, winRate:50,  pnl:-2150,  avgReturnPct:-28 },
    { name:'BAJFINANCE',  trades:2, winRate:0,   pnl:-8350,  avgReturnPct:-95 },
  ],
  weekly:[
    {week:'W11',pnl:-8200},{week:'W12',pnl:12400},{week:'W13',pnl:-6800},
    {week:'W14',pnl:18900},{week:'W15',pnl:8050},
  ],
};

// ── TAB 6 ─────────────────────────────────────────────────────────────────────
export const NIFTY_DATA = Array.from({length:90},(_,i)=>{
  const d=new Date('2025-08-07'); d.setDate(d.getDate()-(89-i));
  if([0,6].includes(d.getDay())) return null;
  const close=+(24500+Math.sin(i*.15)*800+r(-100,100)).toFixed(2);
  const open=+(close+r(-80,80)).toFixed(2);
  const high=+(Math.max(open,close)+r(0,120)).toFixed(2);
  const low=+(Math.min(open,close)-r(0,120)).toFixed(2);
  const prev=24500+Math.sin((i-1)*.15)*800;
  const chgPct=+((close-prev)/prev*100).toFixed(2);
  const vix=+(13+Math.sin(i*.2)*3+r(-0.5,0.5)).toFixed(2);
  const futOI=Math.round(8500000+r(-500000,500000));
  const oiChg=r(-8,8);
  const buildUp=chgPct>0?(oiChg>0?'LB':'SC'):(oiChg>0?'SB':'LU');
  const isExpiry=i%7===4;
  const adv=ri(600,1800),dec=ri(400,1200);
  return {
    date:d.toISOString().split('T')[0],open,high,low,close,chgPct,
    vix,vixChg:r(-1,1),
    futOI,oiChgPct:oiChg,buildUp,isExpiry,
    advDec:{adv,dec,ratio:+(adv/dec).toFixed(2)},
    pcrNear:+(0.9+r(-0.3,0.5)).toFixed(2),pcrNearNext:+(1.0+r(-0.2,0.4)).toFixed(2),
    ceOIMax:24600,peOIMax:24400,
    dii:r(800,3500),fii:r(-2000,2000),
    fiiNetFut:r(-25,25),fiiNetFutOpt:r(-20,20),fiiProFutOpt:r(-15,15),clientFutOpt:r(-10,10),
  };
}).filter(Boolean);

export const NIFTY_AI = {
  date:'2025-08-07',
  sections:{
    fii:    {label:'Bullish',  text:'FII net long futures at +18.4% — highest in 6 weeks; PRO desk turning neutral'},
    pcr:    {label:'Neutral',  text:'PCR Near at 1.18 — above 1.0 support; Max Pain at 24,400, 112 pts below spot'},
    vix:    {label:'Low Fear', text:'VIX at 13.4 — low volatility regime; IV Percentile at 22nd = cheap premium'},
    breadth:{label:'Positive', text:'A/D ratio 1.88 — broad participation; 72% of Nifty 50 stocks positive'},
    fut:    {label:'Long Build',text:'OI up 2.1% with price up — fresh longs being added; continuation bias intact'},
    bias:   {label:'Bullish',  text:'FII positioning + low VIX + long build + positive breadth = short-term bullish; watch 24,300 as key support'},
  },
  history:[
    {date:'2025-08-07',pred:4,actual:4},{date:'2025-08-06',pred:3,actual:2},
    {date:'2025-08-05',pred:4,actual:5},{date:'2025-08-04',pred:3,actual:3},
    {date:'2025-08-01',pred:2,actual:2},{date:'2025-07-31',pred:3,actual:4},
    {date:'2025-07-30',pred:4,actual:4},{date:'2025-07-29',pred:2,actual:1},
    {date:'2025-07-28',pred:3,actual:3},{date:'2025-07-25',pred:5,actual:5},
  ],
};

// ── TAB 7 — AI Summary (aggregated) ──────────────────────────────────────────
export const AI_SUMMARY_DAYS = AI_FEEDBACK.map((day,i)=>({
  ...day,
  overnight: OVERNIGHT,
  marketInterp: NIFTY_AI,
  scannerSummary: i===0 ? [
    {
      type:'High Conviction', color:'#1a6a1a', bg:'rgba(26,106,26,.1)', border:'rgba(26,106,26,.25)',
      fact:'WIPRO and HCLTECH qualify today with 4-day consecutive streak and ★★★★★ confidence — all filters aligned.',
      impl:'Strongest setups of the day. Consider these first if sizing into new positions.',
      tickers:['WIPRO','HCLTECH'],
    },
    {
      type:'Sector Cluster', color:'#1a4a8a', bg:'rgba(26,74,138,.1)', border:'rgba(26,74,138,.25)',
      fact:'4 IT sector stocks qualifying simultaneously — LTIM, PERSISTENT, HCLTECH, KPIT — broad sector momentum.',
      impl:'Sector-level rotation signal. Individual setups are stronger when the whole sector moves together.',
      tickers:['LTIM','PERSISTENT','HCLTECH','KPIT'],
    },
    {
      type:'Fresh Signal', color:'#8a5a00', bg:'rgba(138,90,0,.1)', border:'rgba(138,90,0,.25)',
      fact:'SUNPHARMA appearing today after a 3-day absence — day 1 of a potential new run.',
      impl:'Early entry opportunity but unconfirmed. Treat as watchlist until streak builds to 2–3 days.',
      tickers:['SUNPHARMA'],
    },
  ] : i===1 ? [
    {
      type:'High Conviction', color:'#1a6a1a', bg:'rgba(26,106,26,.1)', border:'rgba(26,106,26,.25)',
      fact:'KPIT qualified for 6th consecutive day with ★★★★★ confidence — persistent signal.',
      impl:'High-conviction continuation setup. Review position sizing.',
      tickers:['KPIT'],
    },
  ] : [],
  tradeSummary: i===0 ? [
    {fact:'KAMA Pullback strategy showing 58% win rate — above historical average of 52%.',rec:'Continue running strategy; consider sizing up on 5-star signals.'},
    {fact:'3 of 4 open positions in IT sector.',rec:'Sector concentration risk — avoid new IT longs until one position closes.'},
    {fact:'Average hold period 4.2 days — within swing trading target range.',rec:'No change needed; exit discipline tracking correctly.'},
  ] : [],
}));
